import { cn } from "@/lib/utils";
import { CO2BreakdownItem } from "@/types";
import { useTranslation } from "react-i18next";

export const DashboardMeasureCard = ({
  title,
  value,
  icon,
  bg,
}: {
  title: string;
  value: CO2BreakdownItem;
  icon: React.ReactNode;
  bg: string;
}) => {
  const { t } = useTranslation();
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
      <div className="font-bold text-[14px] flex items-center space-x-2">
        <span className={cn(bg, "h-4 w-4 rounded-full")}></span>
        <span>
          {t("common.level")} {value.level}
        </span>
      </div>

      <div className="py-4">
        <div className="w-full flex justify-center">{icon}</div>

        <div className="flex items-center justify-center mb-4">
          <div className="flex items-center gap-4">
            <span className="text-[20px] font-bold text-gray-900">
              {t(title)}
            </span>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-2 divide-x divide-[#D0D0D0] ">
        <div className="flex flex-col items-center">
          <div className="font-extrabold text-[30px]">{value.count}</div>
          <div className="font-bold text-[16px] text-[#656565] text-center">
            {t("dashboard.total-invoices")}
          </div>
        </div>
        <div className="flex flex-col items-center">
          <div className="font-extrabold text-[30px]">
            {(value.co2_eq / 1000).toFixed(2)}
          </div>
          <div className="font-bold text-[16px] text-[#656565] text-center">
            ton. CO2 eq.
          </div>
        </div>
        <div className="flex flex-col items-center text-[#65A30C]">
          <div className="font-semibold text-[30px]">
            {value.percentage.toFixed(1)}
          </div>
          <div className="font-bold text-[16px] text-center">%</div>
        </div>
      </div>
    </div>
  );
};
